export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-6">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        <p className="text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} Drive Dobias LLC. All rights reserved.
        </p>
        <div className="flex space-x-4 mt-4 md:mt-0">
          <a href="/rental-policies" className="text-gray-400 hover:text-gray-600">Rental Policy</a>
          <a href="/getting-started" className="text-gray-400 hover:text-gray-600">Getting Started</a>
          <a href="#" className="text-gray-400 hover:text-gray-600">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
}